import React, { useState } from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import {
  Toolbar,
  Grid,
  AppBar,
  useScrollTrigger,
  Grow,
  IconButton,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import styled from 'styled-components';
import Logo from './logo';
import Navigation from './navigation';

const Bar = styled(AppBar)`
  z-index: ${props => props.theme.zIndex.drawer + 1};
`;

const Header = ({ scrollLogo }) => {
  const [state, setState] = useState(false);

  const ShowOnScroll = ({ children }) => {
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 100,
    });
    return (
      <Grow
        in={trigger}
        style={{ transformOrigin: 'bottom center 0' }}
        {...(trigger ? { timeout: 1000 } : {})}
      >
        {children}
      </Grow>
    );
  };

  const toggleDrawer = () => {
    setState(!state);
  };

  const data = useStaticQuery(graphql`
    {
      allSanityService {
        nodes {
          name
        }
      }
      sanitySettings {
        logo {
          asset {
            fluid(maxWidth: 80) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
  `);

  return (
    <React.Fragment>
      <Bar component="header" position="sticky" color="default">
        <Grid
          container
          justify="space-between"
          component={Toolbar}
          variant="dense"
        >
          {scrollLogo ? (
            <ShowOnScroll>
              <Link to="/">
                <Logo
                  fluid={data.sanitySettings.logo.asset.fluid}
                  alt="Company Logo"
                />
              </Link>
            </ShowOnScroll>
          ) : (
            <Link to="/">
              <Logo
                fluid={data.sanitySettings.logo.asset.fluid}
                alt="Company Logo"
              />
            </Link>
          )}

          <IconButton color="primary" onClick={toggleDrawer}>
            <Menu fontSize="large" />
          </IconButton>
        </Grid>
      </Bar>

      <Navigation state={state} toggleDrawer={toggleDrawer} />
    </React.Fragment>
  );
};

export default Header;
